import React from 'react';
import createIcon from '../utils/createIcon';

const DoneIcon = createIcon(<path d="M1.11578 6.35652L5.86291 12L15.1158 1" />, 'Done');

export default DoneIcon;
